module.exports = ".form-group.required label:after {\n  color: #f55753;\n  content: \"*\";\n  font-family: arial;\n  font-size: 20px;\n  position: absolute;\n  margin-left: 2px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/form/components/element/element.component.scss
// module id = ./libs/chassis-core/src/app/forms/form/components/element/element.component.scss
// module chunks = main